import React from 'react'

function Hero() {
    return ( 
        <div className='container p-5 mb-5 border-bottom'>
            <div className='row text-center'>
               <img src="media/images/homeHero.png" alt="Hero Image" className='mb-5' />
               <h1 className='mt-5'>Invest in everything</h1>
               <p>Online platform to invest in stocks, derivatives, mutual funds, and more.</p>
               <a href="https://zerodha-clone-frontend-0bma.onrender.com/signup"><button className='btn btn-primary p-2 fs-5 ' style={{width:'20%', margin: "0 auto"}}>Signup Now</button></a> 
            </div>
        <hr/>
        </div>
      

     );
}

export default Hero;